import { siteMeta, collections } from '@/mocks/content';

const heroCards = collections.slice(0, 4);

export default function HeroSection() {
  return (
    <section id="home" className="relative scroll-mt-nav pt-24 md:pt-28 pb-12 md:pb-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50 via-background-50 to-background-50"></div>
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="absolute top-40 -left-24 w-80 h-80 rounded-full bg-primary-100/60 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="max-w-5xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50 border border-primary-200 text-xs md:text-sm font-medium text-primary-700">
            <i className="ri-fire-line"></i>
            热门 · 分类 · 推荐，一站式内容导航
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            91精选 · 热门视频与资源合集，
            <br className="hidden md:block" />
            快速找到你感兴趣的内容
          </h1>
          <p className="mt-5 max-w-3xl mx-auto text-sm md:text-base leading-relaxed text-foreground-700">
            {siteMeta.intro}
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#trending"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-md cursor-pointer whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              查看热门榜
            </a>
            <a
              href="#collections"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 text-sm font-medium text-foreground-800 bg-background-50 border border-background-300 rounded-md cursor-pointer whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-apps-2-line"></i>
              浏览精选合集
            </a>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {heroCards.map((item, index) => (
            <a
              key={item.id}
              href="#collections"
              className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer transition-colors hover:border-primary-300 animate-fade-up"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  title={`${item.title} - 91精选合集`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-background-50/90 text-[11px] font-medium text-primary-700">
                  {item.categoryName}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-primary-500"></i>
                    {item.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}